import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-shimmer',
	templateUrl: './shimmer.component.html',
	styleUrls: ['./shimmer.component.scss'],
})
export class ShimmerComponent {
	@Input()
	public width = '100%';

	@Input()
	public height?: string;

	@Input()
	public style = '';

	@Input()
	public table?: boolean;

	lines: number[] = [1, 2, 3, 4, 5];
}
